import * as API_CONSTANT from '../constants'

export const getDeviceInfoByDVID = (dvid) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/device/getInfo`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            dvid
        })
    })
    .then(res => res.json())
)

export const getDeviceInfoBatch = (dvids) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/device/batch/getInfo`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            dvids
        })
    })
    .then(res => res.json())
)

export const getDeviceGroupByDEVGID = (devgid) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/device/getGroup`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            devgid
        })
    })
    .then(res => res.json())
)

export const getDeviceGroupBatch = (devgids) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/device/batch/getGroup`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            devgids
        })
    })
    .then(res => res.json())
)

export const createDevice = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/device/create`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(
            items
        )
    })
    .then(res => res.json())
)

export const updateDevice = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/device/update`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(
            items
        )
    })
    .then(res => res.json())
)

export const getDeviceModel = () => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/device/model/get`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({})
    })
    .then(res => res.json())
)

export const updateBuzzerAction = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/device/buzzer/action`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(items)
    })
    .then(res => res.json())
)

